import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

export const TOP_HOLDER_CONCENTRATION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.topHolderConcentration,
    label: "Top Holder Concentration",
    tooltip: CatalogMetricSlugs.top_holder_concentration,
    type: ColumnTypes.percent,
    sortsOn: AssetColumns.topHolderConcentration,
    width: 180,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        const measure = getMeasureValue(item, "top_holder_concentration");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val / 100}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
                type="percent"
            />
        );
    },
};

export const TOP_5_HOLDER_CONCENTRATION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.top5HolderConcentration,
    label: "Top 5 Holder Concentration",
    tooltip: CatalogMetricSlugs.top_5_holder_concentration,
    type: ColumnTypes.percent,
    sortsOn: AssetColumns.top5HolderConcentration,
    width: 180,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        const measure = getMeasureValue(item, "top_5_holder_concentration");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val / 100}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
                type="percent"
            />
        );
    },
};

export const TOP_10_HOLDER_CONCENTRATION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.top10HolderConcentration,
    label: "Top 10 Holder Concentration",
    tooltip: CatalogMetricSlugs.top_10_holder_concentration,
    type: ColumnTypes.percent,
    sortsOn: AssetColumns.top10HolderConcentration,
    width: 180,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        const measure = getMeasureValue(item, "top_10_holder_concentration");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val / 100}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
                type="percent"
            />
        );
    },
};
